import { Dimmer, DimmerDimmable, Loader } from "semantic-ui-react";
import { useEffect, useState } from "react";

export const LoadingWrapper = props => {
    const [overrideLoading, setOverrideLoading] = useState(false)
    const usePageDimmer = !!props.pageDimmer

    useEffect(() => {
        setTimeout(() => {
            setOverrideLoading(true)
        }, 100)
    }, [])

    return (
        <DimmerDimmable dimmed={props.loading && !usePageDimmer}>
            <Dimmer active={props.loading} inverted page={usePageDimmer}>
                {overrideLoading && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                        <Loader active inline="centered">{props.text}</Loader>
                        {props.loadingContent && (
                            <div style={{ minWidth: '20rem' }}>
                                {props.loadingContent}
                            </div>
                        )}
                    </div>
                )}
            </Dimmer>
            {props.children}
        </DimmerDimmable>
    )
}
